module.exports = __webpack_public_path__ + "img/footer-logo.3a29eb35.png";